import { ApiError } from "@/lib/api";

/**
 * "You are offline" and "the server is down" are different facts, and until
 * `PG-PWA01` the Playground said "check your connection" for both (and for a
 * 500). `fetch` rejects with a `TypeError` when the request never got an
 * answer: no network, DNS failure, a refused connection, CORS. An `ApiError`
 * is an answer, so it is never a network failure, whatever its status.
 */
export type NetworkFailureKind = "offline" | "unreachable";

export function isNetworkFailure(error: unknown): boolean {
  if (error instanceof ApiError) return false;
  return error instanceof TypeError;
}

/**
 * Which of the two it was, judged by the browser's own connectivity flag at
 * the moment of asking. `navigator.onLine === false` is reliable in the one
 * direction that matters here: a browser that says it is offline is offline.
 * `true` only means "not known to be offline", which is exactly when the
 * honest word is "unreachable".
 */
export function classifyNetworkFailure(
  error: unknown,
  onLine: boolean = typeof navigator === "undefined" ? true : navigator.onLine,
): NetworkFailureKind | null {
  if (!isNetworkFailure(error)) return null;
  return onLine ? "unreachable" : "offline";
}
